import { render, staticRenderFns } from "./roleNotice.vue?vue&type=template&id=23a40ade&scoped=true"
import script from "./roleNotice.vue?vue&type=script&lang=js"
export * from "./roleNotice.vue?vue&type=script&lang=js"
import style0 from "./roleNotice.vue?vue&type=style&index=0&id=23a40ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a40ade",
  null
  
)

export default component.exports